<script setup lang="ts"></script>

<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="origin-center transition-colors duration-300 ease-in-out"
  >
    <path
      d="M26.8569 24.9737L22.5328 20.6495C23.8433 18.934 24.5621 16.8531 24.5623 14.6573C24.5623 12.0111 23.5317 9.52315 21.6603 7.65206C19.7892 5.78097 17.3016 4.75037 14.6551 4.75037C12.009 4.75037 9.521 5.78097 7.6499 7.65206C3.78727 11.515 3.78727 17.8002 7.6499 21.6625C9.521 23.5339 12.009 24.5645 14.6551 24.5645C16.8509 24.5642 18.9318 23.8455 20.6474 22.535L24.9715 26.8591C25.2316 27.1195 25.5731 27.2497 25.9142 27.2497C26.2554 27.2497 26.5968 27.1195 26.8569 26.8591C27.3778 26.3386 27.3778 25.4942 26.8569 24.9737ZM9.53532 19.7771C6.7124 16.9541 6.71273 12.3607 9.53532 9.53748C10.9028 8.17029 12.7212 7.41703 14.6551 7.41703C16.5894 7.41703 18.4074 8.17029 19.7749 9.53748C21.1424 10.905 21.8957 12.7233 21.8957 14.6573C21.8957 16.5915 21.1424 18.4095 19.7749 19.7771C18.4074 21.1446 16.5894 21.8978 14.6551 21.8978C12.7212 21.8978 10.9028 21.1446 9.53532 19.7771Z"
      class="fill-white"
    />
  </svg>
</template>
